export function isAutoplayAllowed() {
  return true;
}
